import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { queryAssignedElements } from "@lit/reactive-element/decorators/query-assigned-elements.js";
import { DsfTab } from "../Tab/index.js";
import { html } from "lit";
import { prop } from "../../../decorators/prop/index.js";
import { getPaginationWrapperClasses, getRailwayClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const navigationKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Enter", " "];
let DsfTabs = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_placement = "horizontal";
  }
  syncTabs() {
    this.tabs.forEach((el) => {
      el.setSelected(el.value === this.value);
      el.setPlacement(this.dsf_placement);
    });
  }
  handleSlotUpdate() {
    this.syncTabs();
  }
  handleSlotClick(ev) {
    if (!ev.target || !(ev.target instanceof DsfTab)) {
      return;
    }
    const tab = ev.target;
    if (tab.value === this.value) {
      return;
    }
    this.value = tab.value;
    this.emit({ name: "input", payload: this.value });
    this.emit({ name: "change", payload: this.value });
  }
  handleKeyDown(ev) {
    const key = ev.key;
    if (!navigationKeys.includes(key)) {
      return;
    }
    ev.preventDefault();
    ev.stopPropagation();
    const allTabs = [...this.tabs];
    const focusedTab = allTabs.find((r) => r === document.activeElement) || allTabs[0];
    if (["Enter", " "].includes(key)) {
      this.handleSlotClick(ev);
      return;
    }
    const indexIncrement = key === "ArrowDown" || key === "ArrowRight" ? 1 : -1;
    let nextIndex = allTabs.indexOf(focusedTab) + indexIncrement;
    if (nextIndex < 0) {
      nextIndex = allTabs.length - 1;
    }
    if (nextIndex > allTabs.length - 1) {
      nextIndex = 0;
    }
    allTabs[nextIndex].focus();
  }
  async connectedCallback() {
    super.connectedCallback();
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.addEventListener("keydown", this.handleKeyDown);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("keydown", this.handleKeyDown);
  }
  update(changedProperties) {
    if (changedProperties.has("value") || changedProperties.has("dsf_placement")) {
      this.syncTabs();
    }
    super.update(changedProperties);
  }
  render() {
    const paginationWrapperClasses = getPaginationWrapperClasses(this);
    const railwayClasses = getRailwayClasses(this);
    return html`
      <div class="${paginationWrapperClasses}" role="tablist">
        <slot
          @slotchange=${this.handleSlotUpdate}
          @click=${this.handleSlotClick}
          @keydown=${this.handleKeyDown}
        >
        </slot>
        <div class="${railwayClasses}"></div>
      </div>
    `;
  }
};
__decorateClass([
  queryAssignedElements({ selector: "dsf-tab" })
], DsfTabs.prototype, "tabs", 2);
__decorateClass([
  prop({ type: String })
], DsfTabs.prototype, "value", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfTabs.prototype, "dsf_placement", 2);
DsfTabs = __decorateClass([
  defineElement("dsf-tabs")
], DsfTabs);
export {
  DsfTabs
};
